<template>
  <div class="center aligned" style="width: 100%">
    <div class="ui cards" style="justify-content: center; display: flex; padding-top: 10px;">
      <div class="card" >
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="industry huge icon"></i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Financial Report
          </div>
        </div>
        <div class="extra content">
          <div class="ui two tiny buttons">
            <div class="ui blue button"
                 style="background-color: #092442 !important;"
                 @click="navigateTo('Financial_Report')">
              Show Report
            </div>
          </div>
        </div>
      </div>

      <div class="card" v-if="$auth.user().see_invoices">
        <div class="center aligned content" style="color: #092442 !important;">
          <i class="huge icons">
            <i class="chart bar icon"></i>
            <i class="corner zoom-in icon"></i>
          </i>
          <br/>
          <br/>
          <div class="header" style="color: #092442 !important;">
            Show Visits Financial
          </div>
        </div>
        <div class="extra content">
          <div class="ui blue fluid tiny button"
               style="background-color: #092442 !important;"
               @click="navigateTo('Finalize_Visits_Financial')">
            Finish Visits
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  beforeDestroy () {
  }
}
</script>

<style scoped>
  .card {
    background-color: #f5f5f5 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/financial_system/financial_layout/FinancialHomePage.vue